/** 説明文枠。画面の用をプレイヤーへ伝える */
export default function Notice({ children }: { children: React.ReactNode }) {
  return <div className="notice">{children}</div>;
}
